import { Box, Button, FormControl, MenuItem, Select, TextField } from '@mui/material';
import { useStateValue } from '../../../../Hooks/stateProvider';
import axios from 'axios';
import { encrypt } from '../../../../utils/cipher';
import { ls } from '../../../../variables';
import { useNavigate } from "react-router-dom";
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import { VisuallyHiddenInput } from '../../../../components/VisuallyHiddenInput';
import { errorHandler } from '../../../../utils/errorHandling';
import { alert } from '../../../../utils/sweetAlert';

function StateManagement({ params, type, moduleType }) {

  const pmsName = ls.get("pmsName");
  const [{ uploadTrigger }, dispatch] = useStateValue();
  const navigate = useNavigate();
  let remarks;
  if (params.row.cmm_type == "Compliance Reporting Category 1") {
    remarks = [
      { value: "Compliant", label: "Compliant" },
      { value: "Partially Compliant", label: "Partially Compliant" },
      { value: "Compliant(No Change)", label: "Compliant(No Change)" },
      { value: "Not Compliant", label: "Not Compliant" },
      { value: "Not Applicable", label: "Not Applicable" },
    ];
  }
  else {
    remarks = [
      { value: "Yes", label: "Yes" },
      { value: "No", label: "No" },

    ];
  }


  const handleChange = (value, object, type) => {
    dispatch({
      type: "SaveData",
      SaveData: {
        value, object, type
      }
    })
  }

  const handleFileUpload = async (params, file, fileName) => {
    // console.log("paramsss.", params.id + "_" + fileName)

    dispatch({ type: "SHOW_LOADER" });
    const formData = new FormData();
    formData.append('file', file);
    // formData.append('pmsName', pmsName);
    // formData.append('serialNumber', params.id);
    // formData.append('key', "CMM");

    // formData.append("file", file);
    formData.append("fileName",fileName);

    let headers;
    if (moduleType == "cmm") {
      headers = {
        filetype: "CMM",
        fy_year: params.fy_year,
        quarter: params.quarter,
        pmsName: pmsName,
        compliance_percentage: params.compliance_percentage,
        compliance_status: params.compliance_status,
        cmm_id: params.cmm_id,
        cmm_remarks: params.cmm_remarks,
        serialNumber:params.id,
        key:"support",
        authtoken: ls.get("authToken"),
        refreshtoken: ls.get("refreshToken")
      }
    }
    // else {
    //   headers = {
    //     filetype: "HYTR",
    //     fy_year: params.fy_year,
    //     half_year: params.half_year,
    //     pmsName: pmsName,
    //     compliance_percentage: params.compliance_percentage,
    //     compliance_status: params.compliance_status,
    //     hytr_id: params.hytr_id,
    //     hytr_remarks: params.hytr_remarks,
    //     authtoken: ls.get("authToken"),
    //     refreshtoken: ls.get("refreshToken")
    //   }
    // }


    console.log("headersheaders",headers)
    const encryptedHeaders = await encrypt(headers)

    axios
      .post("api/pms/supportDocumentUpload", formData, {
        headers: {
          headers: encryptedHeaders
        }
      })
      .then((response) => {
        if (response.data.success) {
          alert("Uploaded", "File uploaded successfully", "success")
          dispatch({
            type: "CMM_HYTR_UPLOAD",
            uploadTrigger: { trigger: true }
          })
          dispatch({ type: "HIDE_LOADER" });
        }
        else {
          dispatch({ type: "HIDE_LOADER" });
          alert("Oops...", "Something went wrong!", "error")
        }
      })
      .catch((err) => {
        dispatch({ type: "HIDE_LOADER" });
        console.error("Error uploading file:", err);
        errorHandler(err, navigate)
      })
  }
  const handleFileDelete = async (id) => {
    try {
      const payload = {
        id: id,
        moduleType: moduleType,
        pmsName: pmsName,
        authToken: ls.get("authToken"),
        refreshToken: ls.get("refreshToken")
      };
      let encryptedPayload = await encrypt(payload)
      const result = axios.post("/api/pms/deleteDocument", { payload: encryptedPayload });
      result.then((response) => {
        if (response.data.success) {
          dispatch({
            type: "CMM_HYTR_UPLOAD",
            uploadTrigger: { trigger: true }
          })
        }
      });
    }
    catch (err) {
      console.log("err: ", err)
      errorHandler(err, navigate)
    }
  }
  const handleDownload = async (uploadS3FilePath) => {
    try {
      if (uploadS3FilePath == undefined || uploadS3FilePath == "") {
        alert("Sorry!!", "No File Found", "error")
        return;
      }
      //   uploadS3FilePath = await decrypt(uploadS3FilePath);
      const downloadPayload = {
        s3Location: uploadS3FilePath,
        moduleType: moduleType.toUpperCase(),
        authToken: ls.get("authToken"),
        refreshToken: ls.get("refreshToken")
      };
      let encryptedPayload = await encrypt(downloadPayload)
      const result = axios.post("/api/pms/downloadReport", { payload: encryptedPayload });
      result.then((response) => {
        if (response.data.success) {
          window.open(response.data.data, "_self");
        }
      });
    }
    catch (err) {
      console.log("err: ", err)
      errorHandler(err, navigate)
    }

  };

  return (
    <>
      {type == "cmm_remarks"? (
        <TextField
          id="outlined-textarea"
          defaultValue={params.row[type]}
          // disabled={true}
          style={{ width: "100%" }}
          onKeyDown={(event) => {
            event.stopPropagation();
          }}
          onChange={(e) => handleChange(e.target.value, params.row, type)}
          placeholder="Enter Comment"
          multiline
        />
      )
        :
        type == "remarks" ?
          (
            <div style={{ display: "flex", justifyContent: "space-between" }}>
              <Box sx={{ minWidth: 200 }}>
                <FormControl fullWidth>
                  <Select
                    value={params.row.compliance_status}
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    onChange={(e) => handleChange(e.target.value, params.row, "remarks")}
                    MenuProps={{
                      PaperProps: {
                        sx: {
                          "& .MuiMenuItem-root": {
                            padding: 1,
                          },
                        },
                      },
                    }}
                    displayEmpty
                    renderValue={
                      params.row.compliance_status == ""
                        ? () => "Select Status"
                        : () => params.row.compliance_status
                    }
                  >
                    {remarks.map((name) => (
                      <MenuItem key={name.label} value={name.value}>
                        {name.label}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Box>
              {/* </div> */}
            </div>
          )
          : type == "percentage" ? (
            <>
              {
                params.row.compliance_status == "Partially Compliant" ? (
                  <TextField
                    id="outlined-textarea"
                    defaultValue={params.row.compliance_percentage != "" ? params.row.compliance_percentage.split("%")[0] : ""}
                    onChange={(e) => handleChange(e.target.value, params.row, "percentage")}
                    placeholder="Enter Percentage"
                    multiline
                  />
                ) : (
                  <h3>{params.row.compliance_percentage}</h3>
                )
              }
            </>
          ) : type == "upload" ? (
            <>
              {(params.row.uploadedfileName == undefined || params.row.uploadedfileName == "") ?
                <div
                  style={{
                    display: "flex",
                    // flexDirection: "column",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <Button
                    sx={{
                      backgroundColor: "#154063",
                      "&:hover": { backgroundColor: "#154063" },
                    }}
                    className="UploadFileButton"
                    component="label"
                    variant="contained"
                  >
                    UPLOAD
                    <VisuallyHiddenInput
                      type="file"
                      onChange={(event) => {
                        handleFileUpload(params.row, event?.target?.files[0], event?.target?.files[0]?.name)
                      }}
                    />
                  </Button>
                  {/* <h4 style={{ wordBreak: "break-word" }}>
          {rows[params.row.id - 1].UploadedFile.name}
        </h4> */}
                  {/* {params.row.uploadedFiles!='' && <h4 color="black">{"File added"}</h4>} */}
                </div> :
                <div style={{ display: "flex", alignItems: "center", gap: "0.5rem" }}>
                  <h3 style={{ cursor: "pointer" }} onClick={() => handleDownload(params.row.s3Location)}>{params.row.uploadedfileName}</h3>
                  <DeleteForeverIcon sx={{ color: "#e6435b", cursor: "pointer" }} onClick={() => {
                    handleFileDelete(params.row[`${moduleType}_id`])
                  }} />
                </div>
              }
            </>
          ) : (
            <>
              <TextField
                id="outlined-textarea"
                defaultValue={params.row[type]}
                onChange={(e) => handleChange(e.target.value, params.row, type)}
                onKeyDown={(event) => {
                  event.stopPropagation();
                }}
                placeholder={"Enter Number"}
                multiline
              />
            </>
          )
      }
    </>
  )
}

export default StateManagement